import React, { useState, useEffect, Suspense, lazy } from "react";
import { Tab, Nav } from "react-bootstrap";
import { getMasterConfig } from "@src/store/slices/common";
import { useDispatch } from "react-redux";
import FullPageLoader from "@src/common/FullPageLoader";
import { STATUS_SUCCESS } from "@src/config/constant";
import MultiTenure from "./MultiTenure";

// Lazy load all tab components
const BasicPremiumNonCommercial = lazy(() => import("./BasicPremiumNonCommercial"));
const BasicPremiumCommercial = lazy(() => import("./BasicPremiumCommercial"));
const VehicleAge = lazy(() => import("./VehicleAge"));
const AddOns = lazy(() => import("./Addons/AddOns"));
const LoadingRate = lazy(() => import("./LoadingRate"));
const AgentCommission = lazy(() => import("./AgentCommission"));
const AdminFee = lazy(() => import("./AdminFee"));
const XenditFee = lazy(() => import("./XenditFee"));
const WpcDays = lazy(() => import("./WpcDays"));
const Branch = lazy(() => import("../config-pannel-new/Branch"));
const multiTenure = lazy(() => import("./MultiTenure"));


export default function ConfigurationPanel(props: any): ReturnType<React.FC> {
  const [masterConfig, setMasterConfig] = useState<any>({});
  const [activeTab, setActiveTab] = useState("first");
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch: any = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(getMasterConfig())
      .then((res: any) => {
        if (res?.status === STATUS_SUCCESS) {
          setMasterConfig(res.data || {});
        }
      })
      .catch((err: Error) => {
        console.error("Failed to fetch master config:", err);
      })
      .finally(() => {
        setLoading(false);
      });
      //eslint-disable-next-line
  }, []);

  return (
    <>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="top-heading confing-top-heading">
          <h1>Configuration Panel</h1>
        </div>

        <div className="config-panel-outer">
          <Tab.Container
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k || "first")}
            mountOnEnter
            unmountOnExit
          >
            <Nav variant="pills" className="flex-column tab-line">
              <div className="tab-list">
                <Nav.Item><Nav.Link eventKey="first">Basic Premium - Non-Commercial</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="second">Basic Premium - Commercial</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="third">Vehicle Age</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="fourth">Add Ons</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="fifth">Loading Rate</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="sixth">Agent Commission</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="seventh">Admin Fee</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="eighth">Transaction Fee</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="nineth">WPC Days</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="tenth">Branch</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="eleveth">Multi Tenure</Nav.Link></Nav.Item>

              </div>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Suspense fallback={<div>Loading...</div>}>
                  <BasicPremiumNonCommercial masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="second">
                <Suspense fallback={<div>Loading...</div>}>
                  <BasicPremiumCommercial masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="third">
                <Suspense fallback={<div>Loading...</div>}>
                  <VehicleAge masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="fourth">
                <Suspense fallback={<div>Loading...</div>}>
                  <AddOns masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="fifth">
                <Suspense fallback={<div>Loading...</div>}>
                  <LoadingRate masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="sixth">
                <Suspense fallback={<div>Loading...</div>}>
                  <AgentCommission masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="seventh">
                <Suspense fallback={<div>Loading...</div>}>
                  <AdminFee masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="eighth">
                <Suspense fallback={<div>Loading...</div>}>
                  <XenditFee masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="nineth">
                <Suspense fallback={<div>Loading...</div>}>
                  <WpcDays masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

              <Tab.Pane eventKey="tenth">
                <Suspense fallback={<div>Loading...</div>}>
                  <Branch masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>
              <Tab.Pane eventKey="eleveth">
                <Suspense fallback={<div>Loading...</div>}>
                  <MultiTenure masterConfig={masterConfig} />
                </Suspense>
              </Tab.Pane>

            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </>
  );
}
